// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Cca-z","narrowOptionButtons":"Dca-z","noOptions":"Eca-z"};